import React from 'react';

import type { DefaultTheme } from 'styled-components';
import { ThemeProvider } from 'styled-components';

import themes from 'src/styles/index';

// Disable useless errors
const cashedLog = console.error;
console.error = (...args) => {
  const [message] = args;
  if (/Warning: React does not recognize the `.+` prop on a DOM element\./.test(message)) {
    return;
  }

  cashedLog(...args);
};

const StyledComponentsThemeProvider: React.FC<React.PropsWithChildren> = (props) => {
  return (
    <ThemeProvider theme={themes.light as unknown as DefaultTheme}>
      {props.children}
    </ThemeProvider>
  );
};

export default StyledComponentsThemeProvider;
